var _circle, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_2428_63443)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_63443)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "#FBCF3F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1663 20.024C34.3249 20.024 35.2642 19.0847 35.2642 17.926C35.2642 16.7674 34.3249 15.8281 33.1663 15.8281C32.0076 15.8281 31.0684 16.7674 31.0684 17.926C31.0684 19.0847 32.0076 20.024 33.1663 20.024Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8921 34.1708C30.8089 34.1708 30.7288 34.1395 30.6676 34.0831C30.6065 34.0266 30.5689 33.9492 30.5623 33.8663C30.4368 32.2551 30.9376 30.6575 31.9603 29.4062L32.024 29.3294C32.2265 29.1422 32.3648 28.896 32.4194 28.6257C32.4036 28.4991 32.3528 28.3794 32.2727 28.2801C32.1925 28.1808 32.0863 28.1058 31.9659 28.0635C31.6434 27.9556 31.302 27.916 30.9633 27.9473C27.209 28.0448 23.5267 28.9999 20.1983 30.7396C20.1207 30.7769 20.0317 30.7826 19.95 30.7556C19.8683 30.7285 19.8003 30.6707 19.7604 30.5945C19.7205 30.5182 19.7119 30.4294 19.7362 30.3469C19.7606 30.2643 19.8161 30.1945 19.8909 30.1521C23.3096 28.3656 27.0915 27.3846 30.9474 27.2839C31.3809 27.2478 31.8171 27.3053 32.2264 27.4526C32.4685 27.5454 32.6784 27.7066 32.8306 27.9165C32.9829 28.1265 33.0708 28.3761 33.0837 28.6351C33.0363 29.0603 32.8426 29.4558 32.5356 29.7538L32.4738 29.8288C31.5611 30.947 31.1141 32.3738 31.2257 33.8129C31.2327 33.9005 31.2046 33.9872 31.1477 34.0542C31.0908 34.1211 31.0097 34.1627 30.9221 34.1699L30.8921 34.1708Z",
    fill: "#CCA332"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4938 28.0285C29.4378 28.029 29.3826 28.0152 29.3335 27.9885C29.2843 27.9618 29.2427 27.923 29.2127 27.8758C29.1724 27.814 28.2345 26.3335 28.8622 25.1679C28.9051 25.0925 28.9757 25.0369 29.059 25.0129C29.1424 24.989 29.2318 24.9986 29.3081 25.0398C29.3845 25.0809 29.4416 25.1503 29.4674 25.2331C29.4932 25.3159 29.4855 25.4055 29.446 25.4827C29.0084 26.2932 29.7618 27.5048 29.7692 27.5169C29.8017 27.5672 29.8199 27.6253 29.8221 27.6851C29.8242 27.7449 29.8101 27.8041 29.7813 27.8566C29.7525 27.909 29.71 27.9527 29.6584 27.9829C29.6068 28.0132 29.548 28.029 29.4882 28.0285H29.4938Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8979 17.3789C14.8465 17.5569 14.819 17.7409 14.8164 17.9261C14.8164 18.4825 15.0374 19.0161 15.4309 19.4096C15.8243 19.803 16.3579 20.024 16.9143 20.024C17.4707 20.024 18.0043 19.803 18.3978 19.4096C18.7912 19.0161 19.0122 18.4825 19.0122 17.9261C19.0096 17.7409 18.9822 17.5568 18.9307 17.3789H14.8979Z",
    fill: "#CCA332"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2428_63443",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_63443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIconSvg);
export default __webpack_public_path__ + "static/media/ok-icon-svg.d5aef854bddd5814e315cc22b74d6624.svg";
export { ForwardRef as ReactComponent };